<form  [formGroup]="accountablefunctionlinkForm">
  <div class="toggle_view">
    <mat-button-toggle-group
  name="fontStyle"
  aria-label="Font Style"
  color="accent"
  class="m-3"
  
  >
  <mat-button-toggle value="list" color="accent" (click)="onList()"
    ><mat-icon class="example-tab-icon"
      >list</mat-icon
    ></mat-button-toggle
  >
  <mat-button-toggle value="grid" (click)="onGrid()"
    ><mat-icon class="example-tab-icon"
      >view_module</mat-icon
    ></mat-button-toggle
  >
  </mat-button-toggle-group>
  </div>
  <div class="other_contents">
    <!-- <div class="tabs">
      <button class="tab" id="btn_1" data-for-tab="1">Link to Assets</button>
      <button class="tab" id="btn_2" data-for-tab="2">Accountable Function</button>
    </div> -->

    <div class="contents">
      <div class="asset_tab tab_content" id="content2" data-tab="2">
        <div class="top">
          <h2 class="title">Accountable Function</h2>
          <button class="default_secondary-btn" (click)="onPopUpDisplay(accountablefunctions)">Add Function</button>
        </div>

        <!-- <div class="form_input">
            <div class="top">
              <h2 class="title">Accountable Function</h2>
            </div>
            <div class="form">
                
              <div class="input" style="margin-bottom: 1rem">
                <label for="">Accountable Function Name</label>
                <input type="text" class="default_input reference-form" formControlName="AccountableFunctionName"/>
                <mat-error *ngIf="errorHandling('AccountableFunctionName', 'required')">
                  You must provide <strong>accountable function name</strong>
               </mat-error>
              </div>
              <div class="input">
                <label for="">Function Name</label>
                <input type="text" class="default_input reference-form" formControlName="FunctionName"/>
              </div>
              <div class="input">
                <label for="">Functional Email</label>
                <input type="text" class="default_input reference-form" formControlName="FunctionalEmail"/>
              </div>
              <div class="btn_holder">
                <button class="default_primary-button" *ngIf="selectedPipelineDetails" (click)="onSubmit(pipelineassetlinkForm.value)">Submit</button>
                <button class="default_secondary-btn" *ngIf="selectedPipelineDetails" (click)="onCreate()">Create</button>
              </div>
            </div>
          </div> -->
        <!-- ENTRY ENTRY ENTRY====================================ENTRY ENTRY ENTRY=====================ENTRY -->
        <div class="entry_values" formArrayName="AccountableFunctions" *ngIf="gridView">
          <div class="entry" *ngFor="let acctfxn of accountablefunctionlinkForm.get('AccountableFunctions')['controls'] ; index as i" [formGroupName]="i">
            <h1 class="section_name">
                <em class="ti-image"></em> 
              
              <span class="name"><input type="text" name="faculty" style="border: none" id="Faculty" class="input"  placeholder="Accountable Function Name" formControlName="AccountableFunctionName"></span>
              <em class="ti-trash" (click)="onDelete(acctfxn.value, i)"></em> 
            </h1>
            
            <div class="location">
              <p class="other_item">Function Name: <span class="file_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="FunctionName"></span></p>
              <p class="other_item">Functional Email: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="FunctionalEmail"></span></p>
            </div>
          </div>
          <div class="btn_holder">
            <button type="submit"  class="default_primary-button" [disabled]="control().value.length <=0" (click)="onSubmit(accountablefunctionlinkForm.value)" type="submit">
              <ng-container>
                Save  &rarr;
              </ng-container>
            </button>
           </div>
        </div>

        <div class="card mt-3" *ngIf="listView">
          <div class="btn_holder">
            <button type="submit"  class="default_primary-button" [disabled]="control().value.length <=0" (click)="onSubmit(accountablefunctionlinkForm.value)" type="submit">
              <ng-container>
                Save  &rarr;
              </ng-container>
            </button>
           </div>
          <table class="table table-hover" >
            <thead>
              <tr>
                <th scope="col">S/N</th>
                <th scope="col">Accountable Function Name</th>
                <th scope="col">Function Name</th>
                <th scope="col">Functional Email</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody formArrayName="AccountableFunctions">
              <tr  *ngFor="let acctfxn of accountablefunctionlinkForm.get('AccountableFunctions')['controls'] ; index as i" [formGroupName]="i"
              >
                <th scope="row">{{i + 1}}</th>
                <td><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="AccountableFunctionName"></td>
                <td><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="FunctionName"></td>
                <td><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="FunctionalEmail"></td>
                <td><em class="ti-trash" (click)="onDelete(acctfxn.value, i)"></em> </td>
              </tr>
      
            </tbody>
          </table>
      
        </div>
      </div>
    </div>
    
  </div>
</form>
